module.exports = "c";


/*****************
 ** WEBPACK FOOTER
 ** ./parsing/extract-amd/c.js
 ** module id = 6
 ** module chunks = 2
 **/